/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PromptTemplate,
  PromptTemplate$inboundSchema,
} from "./prompttemplate.js";

export type ListPromptTemplatesResult = {
  /**
   * The created prompt template
   */
  templates: Array<PromptTemplate>;
};

/** @internal */
export const ListPromptTemplatesResult$inboundSchema: z.ZodMiniType<
  ListPromptTemplatesResult,
  unknown
> = z.object({
  templates: z.array(PromptTemplate$inboundSchema),
});

export function listPromptTemplatesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListPromptTemplatesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPromptTemplatesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPromptTemplatesResult' from JSON`,
  );
}
